import { v4 as uuidv4 } from 'uuid';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { IKnmJudgment } from '../../../APIPackage/KnmModule/interfaces/IKnmJudgment';
import { IKnmJudgmentCancellation } from '../../../APIPackage/KnmModule/interfaces/IKnmJudgmentCancellation';
import { convertJudgmentSubjectFormValuesToKnmData } from './convertJudgmentSubjectFormValuesToKnmData';
import { convertFormDateValueToKnmDataDate } from '../../../KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertKnmDocumentAttachmentFormValueToKnmData } from '../../../KnmPackage/MainModule/common/convertKnmDocumentAttachmentFormValueToKnmData';

export const convertJudgmentsFormValuesToKnmData = (
  values: IKnmErknmForm,
  isDraft?: boolean,
): IKnmJudgment[] | null => {
  const { judgments } = values;

  if (!judgments) {
    return null;
  }

  return judgments.map(item => {
    const judgment: IKnmJudgment = {
      isNew: isDraft ? item.isNew : null,
      guid: item.guid || uuidv4(),
      dateJudgment: convertFormDateValueToKnmDataDate(item.dateJudgment) || null,
      numberJudgment: item.numberJudgment || null,
      // @ts-ignore
      attachment:
        item.attachment
          ?.map(x => {
            return convertKnmDocumentAttachmentFormValueToKnmData(x);
          })
          .filter(x => x !== null) || null,
      kindJudgment: item.kindJudgment || null,
      court: item.court || null,
      judgmentAction: item.judgmentAction || null,
      judgmentSubjectData: item.judgmentSubjectData
        ? convertJudgmentSubjectFormValuesToKnmData(item.judgmentSubjectData, isDraft)
        : null,
      canceledJudgments:
        item.canceledJudgments?.map(formCanceledJudgment => {
          const canceledJudgment: IKnmJudgmentCancellation = {
            ...formCanceledJudgment,
            guid: formCanceledJudgment.guid || null,
            judgmentSubjectData: formCanceledJudgment.judgmentSubjectData
              ? convertJudgmentSubjectFormValuesToKnmData(formCanceledJudgment.judgmentSubjectData)
              : null,
          };

          return canceledJudgment;
        }) || null,
    };

    return judgment;
  });
};
